import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, FormFeedback, Input } from "reactstrap";

import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { buildSecureFileUrl } from '../../Utils/secureFileUrl';
import TableContainer from "../../components/Common/TableContainer";
import { saveAs } from 'file-saver';
import Papa from "papaparse";
import { formatCurrency, formatDate } from '../../Utils/formatters';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Transaction = props => {
  //meta title
  document.title = "Transaction";
  const { getRequest, postRequest } = useRequests();
  const [isLoading, setIsLoading] = useState(false);
  
  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: {label: 'All', value: 'All'},
      property: {label: 'All', value: 'All'},
      status: 'All',
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = TransactionData;
        if(values.user.value !== 'All') {
          filteredData = filteredData.filter(item => String(item.u_id) === String(values.user.value));
        }
        if(values.property.value !== 'All') {
          filteredData = filteredData.filter(item => String(item.p_id) === String(values.property.value));
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }

        if(filteredData.length > 0) {
          setTransactionTBody(filteredData);
        }
        else {
          setTransactionTBody([]);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [WalletAddress, setWalletAddress] = React.useState('');
  const [PropertyName, setPropertyName] = React.useState('');
  const [Tokens, setTokens] = React.useState('');
  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      pct_id: elementData.pct_id,
      status: elementData.status,
    });
    setWalletAddress(elementData.wallet_address);
    setPropertyName(elementData.property_name);
    setTokens(elementData.token);
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      pct_id: '',
      status: '',
      hash: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
      hash: Yup.string().when('status', {
        is: 'Approved',
        then: (schema) => schema.required("Transaction Hash is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          pct_id: values.pct_id,
          status: values.status,
          hash: values.hash,
        });
        const res = await postRequest('update-property-crypto-transaction-status-manual', jsonpar);
        if (res && res.code === 200) {
            handleLoadGetTransactionData();

            validation2.resetForm();

            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();
        
        
        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "pct_id",
      },
      {
        Header: "First Name",
        accessor: "first_name",
      },
      {
        Header: "Last Name",
        accessor: "last_name",
      },
      {
        Header: "Email ID",
        accessor: "email",
      },
      {
        Header: "Property Name",
        accessor: "property_name",
      },
      {
        Header: "Tokens",
        accessor: "token",
      },
      {
        Header: "Currency",
        accessor: "currency",
      },
      {
        Header: "Amount",
        accessor: row => row.type === "fiat" && row.currency === "Euro" ? 
          parseFloat(row.total_amount) : parseFloat(row.received_amount),
        Cell: ({ row }) => (
          <span>
            {row.original.type === "fiat" && row.original.currency === "Euro" 
              ? parseFloat(row.original.total_amount) 
              : parseFloat(row.original.received_amount)} {row.original.currency}
          </span>
        ),
      },
      {
        Header: "Bank Amount",
        accessor: row => row.total_amount - row.used_euro_wallet_amount,
        Cell: ({ row }) => (
          <span>
            {(row.original.total_amount - row.original.used_euro_wallet_amount).toFixed(2) || 0} {row.original.currency}
          </span>
        ),
      },
      {
        Header: "Bonus Amount",
        accessor: row => row.used_bonus_amount,
        Cell: ({ row }) => (
          <span>
            {row.original.used_bonus_amount || 0} {row.original.currency}
          </span>
        ),
      },
      {
        Header: "Reinvestment Amount",
        accessor: row => row.used_reinvestment_amount,
        Cell: ({ row }) => (
          <span>
            {row.original.used_reinvestment_amount || 0} {row.original.currency}
          </span>
        ),
      },
      {
        Header: "Date",
        accessor: "created_at",
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: () => <div className="text-center">Status</div>,
        accessor: "status",
        Cell: ({ value }) => (
          <div className="text-center">
            <span className={"font-size-14 badge bg-secondary rounded-pill " + 
              (value === 'Pending' ? 'badge-soft-warning' : 
              value === 'Approved' ? 'badge-soft-success' : 
              'badge-soft-danger')}>
              {value}
            </span>
          </div>
        ),
        disableSortBy: true,
      },
      {
        Header: () => <div className="text-center">Actions</div>,
        accessor: "actions",
        Cell: ({ row }) => (
          <div className="centerLink">
            {row.original.status === 'Pending' ? (
              <Button 
                className="font-size-14 bg-primary edit-box" 
                onClick={() => togStandardModal2(row.original)}
              >
                <i className="bx bx-cog"></i>
              </Button>
            ) : ''}
            <span 
              className="font-size-14 bg-primary edit-box" 
              onClick={() => togStandardModal1(row.original)}
            >
              <i className="mdi mdi-eye"></i>
            </span>
          </div>
        ),
        disableSortBy: true,
      },
    ],
    []
  );
  const [FilePath, setFilePath] = React.useState('');
  const [TransactionData, setTransactionData] = React.useState([]);
  const [TransactionTBody, setTransactionTBody] = React.useState([]);

  const handleDownloadCSV = () => {
    const transformedData = TransactionData.map(transaction => ({
      "First Name": transaction.first_name,
      "Last Name": transaction.last_name,
      "Email": transaction.email,
      "Property": transaction.property_name,
      "Token": transaction.token,
      "Currency": transaction.currency,
      "Amount": transaction.type === "fiat" && transaction.currency === "Euro"
        ? formatCurrency(transaction.total_amount)
        : formatCurrency(transaction.received_amount),
      "Bank Amount": `${parseFloat((transaction.total_amount - transaction.used_euro_wallet_amount).toFixed(2) || 0)} ${transaction.currency}`,
      "Bonus Amount": `${transaction.used_bonus_amount || 0} ${transaction.currency}`,
      "Reinvestment Amount": `${transaction.used_reinvestment_amount || 0} ${transaction.currency}`,
      "Date": formatDate(transaction.created_at),
      "Status": transaction.status,
    }));

    const csv = Papa.unparse(transformedData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `transactions_${moment().format('DDMMYYYY_HHmmss')}.csv`);
  };

  const handleLoadGetTransactionData = async () => {
    setIsLoading(true);

    try {
      const res = await getRequest('get-property-crypto-transaction-data');
      if (res && res.code === 200) {
        setTransactionData(res.data.transaction);
        setTransactionTBody(res.data.transaction);
        setFilePath(res.data.url);
        
        setTimeout(() => {
          const submit1 = document.getElementById('submit1');
          if (submit1) {
            submit1.click();
          }
        }, 500);
      }
      else {
        setTransactionData([]);
        setTransactionTBody([]);
      }
    } catch (error) {
      console.error("Error in handleLoadGetTransactionData:", error);
      setTransactionData([]);
        setTransactionTBody([]);
    } finally {
      setIsLoading(false);
    }
  }
  
  const [PropertiesData, setPropertiesData] = React.useState([]);
  const handleLoadGetProperties = async () => {
    setIsLoading(true);

    try {
      const res = await getRequest('get-properties');
      if (res && res.code === 200) {
        let tempArr = [{label: 'All', value: 'All'}];
        res.data.forEach(element => {
          let temp = {
            label: element.property_name,
            value: element.p_id,
          };
          tempArr.push(temp);
        });
        tempArr = [{
          options: tempArr
        }];
        setPropertiesData(tempArr);
      }
      else {
        setPropertiesData([]);
      }
    } catch (error) {
      console.error("Error in handleLoadGetProperties:", error);
      setPropertiesData([]);
    } finally {
      handleLoadGetTransactionData();
    }
  }

  const [UsersData, setUsersData] = React.useState([]);
  const handleLoadGetUsers = async () => {
    setIsLoading(true);

    try {
      const res = await getRequest('get-users');
      if (res && res.code === 200) {
        let tempArr = [{label: 'All', value: 'All'}];
        res.data.forEach(element => {
          let temp = {
              label: `${element.first_name} ${element.last_name} (${element.email})`,
              value: element.u_id,
          };
          tempArr.push(temp);
        });
        if (props.match.params.id) {
          let getUser = tempArr.find(element => String(element.value) === String(atob(props.match.params.id)));
          
          validation1.setValues({
            ...validation1.values,
            user: getUser,
          });

          setTimeout(() => {
            validation1.handleSubmit();
          }, 500);
        }
        tempArr = [{
            options: tempArr
        }];
        setUsersData(tempArr);
      }
      else {
        setUsersData([]);
      }
    } catch (error) {
      console.error("Error in handleLoadGetUsers:", error);
      setUsersData([]);
    } finally {
      handleLoadGetProperties();
    }
  }

  React.useEffect(() => {
    handleLoadGetUsers();
  }, []);


  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Transactions")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="row">
                    <Col md={3} xs={12}>
                      <div className="mb-3 Register-Select2">
                        <label className="form-label">Users : </label>
                        <Select styles={colourStyles} value={validation1.values.user} onChange={(e) => validation1.setValues({ ...validation1.values, user: e })} options={UsersData} classNamePrefix="select2-selection" />
                      </div>
                    </Col>
                    <Col md={3} xs={12}>
                      <div className="mb-3 Register-Select2">
                        <label className="form-label">Properties : </label>
                        <Select styles={colourStyles} value={validation1.values.property} onChange={(e) => validation1.setValues({ ...validation1.values, property: e })} options={PropertiesData} classNamePrefix="select2-selection" />
                      </div>
                    </Col>
                    <Col md={3} xs={12}>
                      <div className="mb-3">
                        <label className="form-label">Status : </label>
                        <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                          <option value={'All'}>All</option>
                          <option value={'Pending'}>Pending</option>
                          <option value={'Approved'}>Approved</option>
                          <option value={'Cancelled'}>Cancelled</option>
                        </select>
                      </div>
                    </Col>
                    <Col md={3} xs={12}>
                      <div className="mb-3">
                        <label className="form-label fullWidth">&nbsp; </label>
                        <Button type="button" 
                          id="submit1"
                          onClick={(e) => {
                            e.preventDefault();
                            validation1.handleSubmit();
                            return false;
                          }}
                        color="primary">Search</Button>
                        <Button type="button" id="submit3" onClick={handleDownloadCSV} color="primary" className="bx bx-download" style={{ float: "right", marginLeft: "10px" }}>
                        </Button>
                      </div>
                    </Col>
                  </div>
                  <TableContainer
                    columns={columns}
                    data={TransactionTBody || []}
                    isGlobalFilter={true}
                    initialSortColumnId="pct_id"
                    initialSortDesc={true}
                    customPageSize={10}
                    className="table-hover table-highlight"
                    isLoading={isLoading}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>


      <Modal isOpen={StandardModal1} backdrop={'static'} centered className="transation" >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Transaction Details</h5>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p className="mb-3">ID : <span className="text-primary">{Transaction.pct_id}	</span></p>
          <p className="mb-3">First Name : <span className="text-primary">{Transaction.first_name}	</span></p>
          <p className="mb-3">Last Name : <span className="text-primary">{Transaction.last_name}</span></p>
          <p className="mb-3">Email ID : <span className="text-primary">{Transaction.email}</span></p>
          <p className="mb-3">Property Name : <span className="text-primary">{Transaction.property_name}</span></p>
          <p className="mb-3">Tokens : <span className="text-primary">{Transaction.token}	</span></p>
          <p className="mb-3">Currency : <span className="text-primary">{Transaction.currency}</span></p>
          <p className="mb-3">Amount : <span className="text-primary">{Transaction.type === "fiat" && Transaction.currency === "Euro" ? formatCurrency(Transaction.total_amount) : parseFloat(Transaction.received_amount)} {Transaction.currency !== "Euro" && Transaction.currency} {parseFloat(Transaction.used_euro_wallet_amount) !== 0 ? <b>( {formatCurrency(Transaction.used_euro_wallet_amount)} spent from euro wallet )</b> : '' }</span></p>
          <p className="mb-3">Bank Amount : <span className="text-primary">{formatCurrency(Transaction.total_amount - Transaction.used_euro_wallet_amount)}</span></p>
          <p className="mb-3">Bonus Amount : <span className="text-primary">{Transaction.used_bonus_amount || 0} {Transaction.currency}</span></p>
          <p className="mb-3">Reinvestment Amount : <span className="text-primary">{Transaction.used_reinvestment_amount || 0} {Transaction.currency}</span></p>
          <p className="mb-3">Date : <span className="text-primary">{formatDate(Transaction.created_at)}</span></p>
          <p className="mb-3">Status : <span className="text-primary"><span className={"font-size-14 badge bg-secondary rounded-pill " + (Transaction.status === 'Pending' ? 'badge-soft-warning' : Transaction.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-secondary')}>{Transaction.status}</span></span></p>
          {Transaction.send_tx !== '' && Transaction.send_tx !== null?
          <p className="mb-3">Transaction Hash : <span className="text-primary"><br />{Transaction.send_tx}</span></p>
          : '' }
          {Transaction.transaction_proof !== '' && Transaction.transaction_proof !== null?
          <p className="mb-3">Transaction Proof : <span className="text-primary"><br /><a rel="noreferrer" target="_blank" href={buildSecureFileUrl(FilePath, Transaction.transaction_proof)} download={Transaction.transaction_proof}>{Transaction.transaction_proof}</a></span></p>
          : '' }
          {Transaction.transaction_information !== '' && Transaction.transaction_information !== null?
          <p className="mb-3">Transaction Information : <span className="text-primary"><br />{Transaction.transaction_information}</span></p>
          : '' }
        </div>
      </Modal>
      
      <Modal className="transation" centered backdrop="static" isOpen={StandardModal2}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Change Status</h5>
          <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Status : </Label>
              <select className="form-select" name="status" value={validation2.values.status} onChange={(e) => validation2.setValues({ ...validation2.values, status: e.target.value })}>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Cancelled">Cancelled</option>
              </select>
              {validation2.touched.status && validation2.errors.status ? (
                <FormFeedback type="invalid">{validation2.errors.status}</FormFeedback>
              ) : null}
            </div>
          </Col>
          {validation2.values.status === 'Approved' && (
            <>
              <Col md={12}>
                <div className="mb-3">
                  <Label className="form-label">Wallet Address : {WalletAddress}</Label>
                </div>
                <div className="mb-3">
                  <Label className="form-label">Property Name : {PropertyName}</Label>
                </div>
                <div className="mb-3">
                  <Label className="form-label">Tokens : {Tokens}</Label>
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <Label className="form-label">Transaction Hash : </Label>
                  <Input
                    type="text"
                    className="form-control"
                    name="hash"
                    value={validation2.values.hash}
                    onChange={validation2.handleChange}
                    onBlur={validation2.handleBlur}
                    placeholder="Enter transaction hash"
                    invalid={
                      validation2.touched.hash && validation2.errors.hash ? true : false
                    }
                  />
                  {validation2.touched.hash && validation2.errors.hash ? (
                    <FormFeedback type="invalid">{validation2.errors.hash}</FormFeedback>
                  ) : null}
                </div>
              </Col>
            </>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary"
            id="submit2"
            onClick={(e) => {
              e.preventDefault();
              validation2.handleSubmit();
              return false;
            }}
          > Update </button>
          <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal2(false)} aria-label="Close">Close</button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(Transaction);